<template>
  <div
    id="settings-view"
    class="flex"
    :class="{'announcement-space': showAnnouncement }">
    <div class="settings-menu">
      <!-- USER section -->
      <h5>Me</h5>

      <router-link
        :to="{ name: 'MyNotifications' }"
        tag="p"
        class="list-item" >
        Notifications
      </router-link>

      <!-- ORGANISATION section - Only admin, owner and incognito can view organisation settings but the menu should not be hidden for other users. -->
      <template>
        <h5>Organisation</h5>

        <router-link
          :to="{ name: 'OrganisationInfo' }"
          tag="p"
          class="list-item" >
          Info
        </router-link>

        <router-link
          :to="{ name: 'NumbersSettings' }"
          tag="p"
          class="list-item" >
          Numbers
        </router-link>

        <router-link
          :to="{ name: 'TeamMemberSettings' }"
          tag="p"
          class="list-item" >
          Members
        </router-link>

        <router-link
          :to="{ name: 'BillingSettings' }"
          tag="p"
          class="list-item" >
          Billing
        </router-link>

        <!-- CONTACT FIELDS -->
        <router-link
          :to="{ name: 'ContactFieldsSettings' }"
          tag="p"
          class="list-item" >
          Contact fields
        </router-link>

        <!-- TAGS -->
        <router-link
          :to="{ name: 'TagsSettings' }"
          tag="p"
          class="list-item" >
          Tags
        </router-link>

        <!-- QUICK REPLIES -->
        <router-link
          :to="{ name: 'QuickRepliesSettings' }"
          tag="p"
          class="list-item" >
          Quick replies
        </router-link>

        <router-link
          :to="{ name: 'PermissionSettings' }"
          tag="p"
          class="list-item" >
          Permissions
        </router-link>

        <router-link
          v-if="currentOrganisation.businesses.length"
          :to="{ name: 'NumberManage', params: { businessId: currentOrganisation.businesses[0].id } }"
          tag="p"
          class="list-item pop-out flex flex-align-center" >
          <span class="greedy">Number settings are moved to Manage</span>
          <SBIcon
            :icon="SBIconList.ARROW_45"
            :size="14"
            :border-radius="0"
            :color="SBColors.greyPrimary"
            :active="false" />
        </router-link>
      </template>

      <!-- NUMBER section -->
      <template v-if="currentOrganisation.businesses.length">
        <!-- BRANCH SELECT -->
        <!-- <div
          id="branch-select-id"
          class="branch-select flex flex-align-center"
          :class="{ active: selectBranchActive }"
          @mouseover="mouseOverBranchSelect"
          @mouseout="mouseOutBranchSelect"
          @click="toggleBranchSelect" >
          <VNodes :vnodes="getNumberIcon(selectedBranch)"/>
          <p class="greedy">{{ selectedBranch.name }}</p>
          <SBIcon
            :icon="SBIconList.DOWN_ARROW"
            :size="11"
            :color="selectBranchHover || selectBranchActive ? SBColors.blackPrimary : SBColors.blackUltralight"
            :active="false" />
        </div> -->

        <!-- <router-link
          :to="{ name: 'WhatsAppProfile', params: { numberId: selectedBranch.id } }"
          tag="p"
          class="list-item" >
          WhatsApp profile
        </router-link> -->

        <!-- <router-link
          :to="{ name: 'AutomatedResponsesSettings', params: { numberId: selectedBranch.id } }"
          tag="p"
          class="list-item flex flex-align-center"
          role="tab" >
          <SBIcon
            :icon="SBIconList.BOT_ON"
            :size="12"
            :color="SBColors.blackPrimary"
            :active="false" />
          Automated responses
        </router-link> -->
        <b-collapse
          accordion="settingsSubsections"
          class="settings-subsection"
          role="tabpanel"
          :visible="checkPermission('manage_settings') && showAutomatedResponseSubsection" >
          <router-link
            :to="{ name: 'AutomatedResponsesPreferenceSettings', params: { numberId: selectedBranch.id } }"
            tag="p"
            class="list-item" >
            Settings
          </router-link>
        </b-collapse>

        <!-- <router-link
          :to="{ name: 'MessageTemplates', params: { numberId: selectedBranch.id } }"
          tag="p"
          class="list-item" >
          WhatsApp Message Templates
        </router-link> -->
        <b-collapse
          accordion="templatesSubsections"
          class="settings-subsection"
          role="tabpanel"
          :visible="checkPermission('manage_settings') && showSettingsSubsection" >
          <!-- <router-link
            :to="{ name: 'MessageTemplatesActivity', params: { numberId: selectedBranch.id } }"
            tag="p"
            class="list-item" >
            Activity
          </router-link> -->
        </b-collapse>

        <!-- <router-link
          :to="{ name: 'WorkingHours', params: { numberId: selectedBranch.id } }"
          tag="p"
          class="list-item" >
          Working hours
        </router-link> -->

        <!-- <router-link
          :to="{ name: 'ConsentManagement', params: { numberId: selectedBranch.id } }"
          tag="p"
          class="list-item" >
          Consent management
        </router-link> -->

        <!-- <router-link
          :to="{ name: 'BlocklistSettings', params: { numberId: selectedBranch.id } }"
          tag="p"
          class="list-item" >
          Blocked contacts
        </router-link> -->

        <!-- active-class="settings-nav__list-item--active"
          class="settings-nav__list-item" -->

        <!-- <router-link
          :to="{ name: 'ApiSettings', params: { numberId: selectedBranch.id } }"
          tag="p"
          class="list-item"
          role="tab" >
          API
        </router-link>
        <b-collapse
          accordion="settingsSubsections"
          class="settings-subsection"
          role="tabpanel"
          :visible="checkPermission('manage_settings') && showApiSubsection" >
          <router-link
            :to="{ name: 'WebhooksSettings', params: { numberId: selectedBranch.id } }"
            tag="p"
            class="list-item" >
            Webhooks
          </router-link>
          <router-link
            :to="{ name: 'WebhookLogsSettings', params: { numberId: selectedBranch.id } }"
            tag="p"
            class="list-item" >
            Webhook logs
          </router-link>
        </b-collapse> -->

        <!-- <b-popover
          ref="branchFilterPopover"
          target="branch-select-id"
          triggers="manual"
          placement="bottomright"
          custom-class="interactive-popover hide-arrow m-0 mt-1"
          boundary-padding="11" >
          <SelectBranch
            v-click-outside="closeBranchSelect"
            title="Numbers"
            :only-available="!checkPermission('manage_organisation_settings')"
            :selected-branch="selectedBranch"
            @branch-selected="selectBranch" />
        </b-popover>-->
      </template>

      <!-- <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><hr> -->

      <!-- TODO - remove - it is here just for the refference until all new sections are finished -->
      <!-- <div class="settings-header"/> -->
      <!-- <aside
        v-click-outside="hideSettingsNav"
        :class="{opened: settingsNavOpened}"
        class="settings-nav">
        <span
          class="settings-toggle-button"
          @click="toggleSettingsNav">
          <icon
            v-if="settingsNavOpened"
            name="chevron-left"/>
          <icon
            v-else
            name="bars"/>
        </span>
        <div class="menu-items scroll-area">
          <router-link
            :to="backLink"
            tag="div"
            class="back-to-list">
            <icon
              name="angle-left"
              width="14"
              height="14"/> <span>Back</span>
          </router-link>
          <h2>General</h2> -->
          <!--<router-link-->
          <!--:to="{ name: 'ChatSettings' }"-->
          <!--tag="span"-->
          <!--active-class="settings-nav__list-item--active"-->
          <!--class="settings-nav__list-item">
          Chat
          </router-link>-->
          <!-- <router-link
            :to="{ name: 'AvailabilitySettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Availability
          </router-link>
          <router-link
            :to="{ name: 'AutomationSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Automation
          </router-link>
          <router-link
            :to="{ name: 'SubscriberSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Subscribers
          </router-link>
          <router-link
            :to="{ name: 'ContactSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Contacts
          </router-link> -->
          <!--<router-link
            :to="{ name: 'PaymentSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Payments
          </router-link>
          <router-link
            :to="{ name: 'TaxesSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Taxes
          </router-link>-->
          <!--<router-link
            :to="{ name: 'PaymentGatewaySettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Payment Gateways
          </router-link>-->
          <!--<router-link
            :to="{ name: 'BusinessInfoSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Business info
          </router-link>-->
          <!-- <router-link
            :to="{ name: 'TeamSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Teams
          </router-link>
          <router-link
            :to="{ name: 'TeamMemberSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Members
          </router-link>
          <router-link
            :to="{ name: 'PermissionSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Permissions
          </router-link> -->
          <!-- router-link
            :to="{ name: 'IntegrationList' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Integrations
          </router-link -->
          <!-- <router-link
            :to="{ name: 'PlanBillingSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Plan + Billing
          </router-link> -->

          <!-- h2 class="mt-3">WhatsApp</h2 -->
          <!--<router-link
            :to="{ name: 'WhatsappConnectSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Connect
          </router-link>-->
          <!-- router-link
            :to="{ name: 'WhatsappProfileSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Profile
          </router-link -->
          <!-- <h2 class="mt-3">API</h2>
          <router-link
            :to="{ name: 'ApiKeySettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            API Keys
          </router-link>
          <router-link
            :to="{ name: 'WebhookSettings' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Webhooks
          </router-link>
          <router-link
            :to="{ name: 'WebhookLogs' }"
            tag="span"
            active-class="settings-nav__list-item--active"
            class="settings-nav__list-item">
            Webhook Logs
          </router-link>
        </div>
      </aside> -->
    </div>
    <router-view
      class="settings-content greedy"
      :business="selectedBranch"/> <!-- TODO provide business info via router props - v3 - Because if prop is not consumed then it is visible in the dom as `business="[object Object]"` -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClickOutside from 'v-click-outside';

import { roleInCurrentOrganisation } from '@/helpers/guards/roleInMerchant';
import SettingsNavMixin from '@/mixins/SettingsNav';
import { getNumberIcon } from '@/helpers/lists/branchIcons';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SelectBranch from '@/components/business/branch/SelectBranch';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import VNodes from '@/components/common/VNodes';

export default {
  name: 'SettingsNav',
  components: {
    SBIcon,
    SelectBranch,
    VNodes,
  },
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  mixins: [
    SettingsNavMixin,
    UserPermissionsMixin,
  ],
  props: {},
  data() {
    return {
      selectedBranch: {},
      selectBranchActive: false,
      selectBranchHover: false,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisation: 'organisation/currentOrganisation',
      incognito: 'user/incognito',
      showAnnouncement: 'system/showAnnouncement',
    }),
    showApiSubsection() {
      const apiSections = [
        'ApiSettings',
        'WebhooksSettings',
        'WebhookLogsSettings',
      ];
      return apiSections.includes(this.$route.name);
    },
    showAutomatedResponseSubsection() {
      const apiSections = [
        'AutomatedResponsesSettings',
        'AutomatedResponsesPreferenceSettings',
      ];
      return apiSections.includes(this.$route.name);
    },
    showSettingsSubsection() {
      const apiSections = [
        'MessageTemplates',
        'MessageTemplatesActivity',
      ];
      return apiSections.includes(this.$route.name);
    },
  },
  watch: {
    $route(to) {
      if (to.params.numberId) {
        this.setNumber(this.$route.params.numberId);
      }
    },
    currentOrganisation() {
      // Needed when the user reloads here or gets here via link
      if (this.currentOrganisation.businesses[0]) {
        if (this.$route.params.numberId) {
          this.setNumber(this.$route.params.numberId);
        } else {
          // this.selectedBranch = this.currentOrganisation.businesses[0];
          this.setNumber(this.currentOrganisation.businesses[0].id);
        }
      }
    },
  },
  mounted() {
    // this.fetchMerchantRoles();
    // Needed when the user navigates here
    if (this.$route.params.numberId) {
      this.setNumber(this.$route.params.numberId);
    } else if (this.currentOrganisation.businesses[0]) {
      // this.selectedBranch = this.currentOrganisation.businesses[0];
      this.setNumber(this.currentOrganisation.businesses[0].id);
    }

    // this.fetchOrganisationNumbers();
  },
  methods: {
    ...mapActions({
      fetchMerchantRoles: 'user/fetchMerchantRoles',
      // fetchOrganisationNumbers: 'organisation/fetchOrganisationNumbers',
    }),
    getNumberIcon,
    /** Temporary method to print the business logo untill we implement the feature for users to change the logo. */
    getBusinessIndex(businessId) {
      return this.currentOrganisation.businesses.findIndex(business => business.id === businessId);
    },
    mouseOverBranchSelect() {
      this.selectBranchHover = true;
    },
    mouseOutBranchSelect() {
      this.selectBranchHover = false;
    },
    selectBranch(branch) {
      this.selectedBranch = branch;
      // Only change route if user is in the number settings area
      if (this.$route.params.numberId) {
        this.$router.push({ name: this.$route.name, params: { numberId: branch.id } });
      }
      this.toggleBranchSelect();
    },
    setNumber(numberId) {
      if (numberId !== this.selectedBranch.id) {
        const selectNumber = this.currentOrganisation.businesses.find(business => business.id === numberId);
        if (selectNumber) {
          this.selectedBranch = selectNumber;
        } else if (this.currentOrganisation.businesses[0]) {
          this.selectedBranch = this.currentOrganisation.businesses[0];
        }
      }
    },
    closeBranchSelect() {
      this.selectBranchActive = false;
      this.$refs.branchFilterPopover.$emit('close');
    },
    toggleBranchSelect() {
      this.selectBranchActive = !this.selectBranchActive;
      if (this.selectBranchActive) {
        this.$refs.branchFilterPopover.$emit('open');
      } else {
        this.$refs.branchFilterPopover.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#settings-view {
  display: flex;
  width: 100%;
  background: $white;

  .settings-menu {
    // height: 100%;
    width: 100%;
    max-width: 339px;
    background: $white;
    padding: 12px;
    overflow: auto;
    border-right: 1px solid $greyBorderSecondary;

    .settings-subsection {
      display: block;
      margin-left: 24px;
    }

    h5 {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.2;
      color: $blackUltralight;
      padding: 8px;
      margin: 22px 0 0 0;
      cursor: default;

      &:first-child {
        margin-top: 0;
      }
    }

    .branch-select {
      position: relative;
      margin-top: 23px;
      padding: 6px 8px;
      font-size: 14px;
      line-height: 1.2;
      color: $blackUltralight;
      cursor: pointer;
      border-radius: 5px;

      background-color: $greyChatBubble;

      &:first-child {
        margin-top: 0px;
      }

      .branch-icon {
        margin-right: 6px;
        // letter-spacing: 3px;
        font-size: 12px !important;

        &.FRONTAPP,
        &.FRONTPACHA {
          background-image: url('~@/assets/img/SB-Icons/integration-front-color.svg');
          background-size: 12px 12px;
          background-position: center center;
          background-repeat: no-repeat;
          display: block;
          width: 15px;
          height: 15px;
          transform: translateY(0);
        }
      }

      .sb-icon {
        transition: transform 0.2s ease;
      }

      &:hover, &.active {
        background-color: $greyChatBubble;
        * {
          color: $blackPrimary !important;
        }
      }

      &.active {
        .sb-icon {
          // TODO enable once we add it to all dropdowns
          // transform: rotateZ(180deg);
        }
      }
    }

    .list-item {
      margin: 6px 0 0 0;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.2;
      padding: 6px 8px;
      border-radius: 5px;
      color: $blackPrimary;
      cursor: pointer;

      /* TODO - remove this class once all the settings items are implemented */
      &.not-implemented {
        color: $greyPrimary;
        &::after {
          content: " TODO";
          font-size: 8px;
          color: red;
        }
      }

      &:hover {
        background-color: $mainBg;
      }

      &.router-link-active {
        background-color: $bluePrimary;
        color: $white;
      }

      &.pop-out {
        margin-block: 25px;
        padding: 10px 12px 10px 10px;
        border-radius: 6px;
        background-color: #f4faff;

        &:hover {
        cursor: pointer;
        background-color: #edf7ff;
        ::v-deep .sb-icon .icon.mask {
            background-color: $blackPrimary !important;
        }
      }
      }
    }
  }

  ::v-deep .settings-content {
    overflow: auto;
    padding: 0 40px;
    background: $white;

    /*
      Overrides due to a layout issue with clipped elements with negative margin.
      TODO - Fix this in rewrite.
    */
    &.no-margin {
      padding: 0px !important;

      .settings__title {
        padding-left: 40px;
        padding-right: 40px;
      }

      .response-items {
        // padding-left: 40px !important;
      }

      .response-preview {
        margin-right: 40px;
      }
    }
  }
}

::v-deep .list-item.router-link-exact-active .sb-icon .icon.mask {
  background-color: $white !important;
}
</style>

<style lang="scss">
.interactive-popover {
  #select-branch .branch-icon-wrapper .branch-icon {
    // font-size: 12px !important;
  }
}
</style>
